export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const LOGGED_IN_COOKIE = 'logged_in';
